import { WarrantyCoverage } from './coverage';

export enum RenewalStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface RenewalEligibility {
  eligible: boolean;
  reason: string | null;
}

export interface RenewalCoverageOption extends WarrantyCoverage {
  title: string;
  /** True when this coverage exists on the warranty being renewed today. */
  isCarriedForward: boolean;
  /** True when this coverage was not previously covered and is newly offered by the policy. */
  isNew: boolean;
  /** Whether the customer may deselect this coverage (required coverages cannot be removed). */
  isRemovable: boolean;
  /** Selected by default for the review step (2.5). */
  selectedByDefault: boolean;
}

export interface RenewalPreview {
  warrantyId: string;
  contractNumber: string;
  renewalCount: number;
  policyId: string;
  policyTitle: string;
  planId: string;
  planTitle: string;
  termId: string;
  termDuration: number;
  currentExpiryDate: Date;
  /** Projected new expiry date if every default-selected coverage is kept as-is. */
  newExpiryDate: Date;
  /** Coverages on the current warranty that are no longer offered/valid and cannot be carried forward (2.3). */
  unavailableCoverageIds: string[];
  coverageOptions: RenewalCoverageOption[];
  totalAmountDue: number;
}

export interface ConfirmRenewalRequest {
  selectedCoverageIds: string[];
  paymentMethodId: string;
}

export interface RenewalResult {
  warrantyId: string;
  contractNumber: string;
  renewalCount: number;
  expiryDate: Date;
  coverages: WarrantyCoverage[];
  totalAmountPaid: number;
}
